export const getAllChildrensId = (objeto, ids = []) => {
  // Primero, verificamos si el objeto actual tiene un id y lo agregamos al array de ids.
  if (objeto.hasOwnProperty('id')) {
    ids.push(objeto.id)
  }

  // Luego, verificamos si el objeto tiene una propiedad 'children' que sea un array.
  if (Array.isArray(objeto.children) && objeto.children.length > 0) {
    // Recorremos cada hijo y llamamos a la función de manera recursiva.
    objeto.children.forEach((child) => getAllChildrensId(child, ids))
  }

  return ids // Devolvemos el array de ids recopilado.
}
